import React, { useState, useEffect } from "react";
import { MultiSelect } from "primereact/multiselect";
import { PlusCircle } from "lucide-react";
import getFinancialYear from "../../helper/getFinancialYear";

const ProjectForm = ({
  project,
  handleChange,
  error,
  data,
  firmData,
  locationData,
  managerData,
  departmentData,
  getAdminPartyData,
  contractorData,
  isCompleted,
  handleCompletedRadio,
  selectValue,
  handleRadioChange,
  openModal,
  selectedCon,
  handleEditFormChange,
}) => {
  const [conOptions, setConOptions] = useState([]);

  // Convert contractor data to options format for MultiSelect
  useEffect(() => {
    if (contractorData) {
      const options = contractorData.map((n) => ({
        label: n?.name,
        value: n?._id,
      }));
      setConOptions(options);
    }
  }, [contractorData]);

  const financialYear = getFinancialYear();

  return (
    <form>
      <div className="col-12">
        <div className="form-heading">
          <h4>{data?._id ? "Edit" : "Add"} Project Details</h4>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              {" "}
              Firm <span className="login-danger">*</span>
            </label>
            <select
              className="form-select"
              value={project.firm}
              name="firm"
              disabled
              onChange={handleChange}
            >
              <option value="">Select Firm</option>
              {firmData?.map((e) => (
                <option key={e?._id} value={e?._id}>
                  {e.name}
                </option>
              ))}
            </select>
            <div className="error">{error.firm_err}</div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              {" "}
              Year <span className="login-danger">*</span>
            </label>
            <select
              className="form-select"
              value={financialYear.id}
              disabled
              name="year"
              onChange={handleChange}
            >
              <option value={financialYear.id}>{financialYear.label}</option>
            </select>
            <div className="error">{error.year_err}</div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Project No <span className="login-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              value={project.project_no}
              name="project_no"
              onChange={handleChange}
            />
            <div className="error">{error.project_no_err}</div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Project Name <span className="login-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              value={project.name}
              name="name"
              onChange={handleChange}
            />
            <div className="error">{error.name_err}</div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Project Type <span className="login-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              value={project.label}
              name="label"
              onChange={handleChange}
            />
            <div className="error">{error.label_err}</div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Work Order / PO No. <span className="login-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              value={project.work_order_no}
              name="work_order_no"
              onChange={handleChange}
            />
            <div className="error">{error.work_order_no_err}</div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              PO Date <span className="login-danger">*</span>
            </label>
            <input
              className="form-control"
              type="date"
              value={project.po_date}
              name="po_date"
              onChange={handleChange}
            />
            <div className="error">{error.po_date_err}</div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms d-flex align-items-center gap-2 mb-0">
            <label>
              Project Location <span className="login-danger">*</span>
            </label>
            <select
              className="form-control form-select"
              value={project.location}
              name="location"
              onChange={handleChange}
            >
              <option value="">Select Project Location</option>
              {locationData?.map((e, i) => (
                <option value={e?._id} key={i}>
                  {e?.name}
                </option>
              ))}
            </select>
            <div className="mb-2 h-100">
              <button
                type="button"
                className="btn p-2 mt-2 btn-sm btn-outline-primary d-flex align-items-center gap-1"
                data-bs-toggle="tooltip"
                data-bs-title="Add Location"
                onClick={() => openModal("location")}
              >
                <PlusCircle size={16} />
              </button>
            </div>
          </div>
          <div className="error mt-0">{error.location_err}</div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms d-flex align-items-center gap-2 mb-0">
            <label>
              {" "}
              Manager <span className="login-danger">*</span>
            </label>
            <select
              className="form-select"
              value={project.manager}
              name="manager"
              onChange={handleChange}
            >
              <option value="">Select Manager</option>
              {managerData?.map((e) => (
                <option key={e?._id} value={e?._id}>
                  {e?.name}
                </option>
              ))}
            </select>
            <div className="mb-2 h-100">
              <button
                type="button"
                className="btn p-2 mt-2 btn-sm btn-outline-primary d-flex align-items-center gap-1"
                data-bs-toggle="tooltip"
                data-bs-title="Add Manager"
                onClick={() => openModal("manager")}
              >
                <PlusCircle size={16} />
              </button>
            </div>
          </div>
          <div className="error mt-0">{error.manager_err}</div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms d-flex align-items-center gap-2 mb-0">
            <label> Department </label>
            <select
              className="form-select"
              value={project.department}
              name="department"
              onChange={handleChange}
            >
              <option>Select Department</option>
              {departmentData?.map((e) => (
                <option key={e?._id} value={e?._id}>
                  {e?.name}
                </option>
              ))}
            </select>
            <div className="mb-2 h-100">
              <button
                type="button"
                className="btn p-2 mt-2 btn-sm btn-outline-primary d-flex align-items-center gap-1"
                data-bs-toggle="tooltip"
                data-bs-title="Add Department"
                onClick={() => openModal("department")}
              >
                <PlusCircle size={16} />
              </button>
            </div>
          </div>
          <div className="error">{error.dept_err}</div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms d-flex align-items-center gap-2 mb-0">
            <label>
              {" "}
              Client <span className="login-danger">*</span>
            </label>
            <select
              className="form-select"
              value={project.party}
              name="party"
              onChange={handleChange}
            >
              <option>Select Client</option>
              {getAdminPartyData?.map((e) => (
                <option key={e?._id} value={e?._id}>
                  {e?.name}
                </option>
              ))}
            </select>
            <div className="mb-2 h-100">
              <button
                type="button"
                className="btn p-2 mt-2 btn-sm btn-outline-primary d-flex align-items-center gap-1"
                data-bs-toggle="tooltip"
                data-bs-title="Add Client"
                onClick={() => openModal("client")}
              >
                <PlusCircle size={16} />
              </button>
            </div>
          </div>
          <div className="error mt-0">{error.party_err}</div>
        </div>

        <div className="col-12 col-md-4 col-xl-4 mt-4">
          <div className="input-block local-forms">
            <label> Start Date </label>
            <input
              className="form-control"
              type="date"
              value={project.startDate}
              name="startDate"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4 mt-4">
          <div className="input-block local-forms">
            <label> End Date </label>
            <input
              className="form-control"
              type="date"
              value={project.endDate}
              name="endDate"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4 mt-4">
          <div className="input-block local-forms custom-select-wpr d-flex gap-2 align-items-center">
            <label> Contractor</label>
            <MultiSelect
              value={selectedCon?.map((c) => c.conId)}
              onChange={(e) =>
                handleEditFormChange({
                  target: {
                    name: "conId",
                    value: e.value.map((id) => ({ conId: id })),
                  },
                })
              }
              options={conOptions}
              optionLabel="label"
              placeholder="Select Contractor"
              className="w-100 multi-prime-react"
            />
            <div className="mb-2 h-100">
              <button
                type="button"
                className="btn p-2 mt-1 btn-sm btn-outline-primary d-flex align-items-center gap-1"
                data-bs-toggle="tooltip"
                data-bs-title="Add Contractor"
                onClick={() => openModal("contractor")}
              >
                <PlusCircle size={16} />
              </button>
            </div>
          </div>
          <div className="error">{error.contractor_err}</div>
        </div>

        <div className="col-12 col-md-12 col-xl-12">
          <div className="input-block local-forms">
            <label>
              {" "}
              Details <span className="login-danger">*</span>
            </label>
            <textarea
              className="form-control"
              value={project.details}
              name="details"
              onChange={handleChange}
              rows="3"
            />
            <div className="error">{error.detail_err}</div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-xl-4">
          <div className="cardNum">
            <div className="mb-3">
              <label htmlFor="fileUpload" className="form-label">
                Project Completed
              </label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  onChange={handleCompletedRadio}
                  checked={isCompleted}
                />
                <span>{isCompleted ? "Yes" : "No"}</span>
              </div>
            </div>
          </div>
        </div>

        {data?._id ? (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="cardNum">
              <div className="mb-3">
                <label className="form-label">Status</label>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    onChange={handleRadioChange}
                    checked={selectValue}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </form>
  );
};

export default ProjectForm;
